define('GameDayCore/GDModel/ValueObjects/Gamecenter/GamecenterVideo',['require','exports','module','../ValueObjectFactory','./GamecenterPlaybackScenario'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(GamecenterVideo);

	function GamecenterVideo($data) {
		var vo = VO.ensureVO(this, GamecenterVideo),
			data = $data;

		switch (undefined) {
			case data.media:
			case data.meta:
			case data.url:
				return null;
				break;
		}

		vo.title = data.title || "";
		vo.content_id = data.meta.content_id || "";
		vo.link_type = data.meta.linke_type || "";
		vo.topic_id = data.meta.topic_id || "";
		vo.calendar_event_id = data.meta.calendar_event_id || "";
		vo.view_key = data.meta.view_key || "";
		vo.duration = data.meta.duration || "";
		vo.pid = data.media.pid || "";
		vo.type = data.media.type || "";
		vo.free = (data.media.true === "T");
		vo.feed_code = data.media.free_code || "";
		vo.dds_id = data.media.dds_id || "";
		vo.date = data.media.date || "";
		vo.state = data.media.state || "";
		vo.game_id = data.media.game_id || "";
		vo.blackout = data.media.blackout || "local";
		vo.playback_scenarios = parsePlaybacks(data);
	}

	function parsePlaybacks(data) {
		var playbacks = [],
			urls = [].concat(data.url),
			GamecenterPlaybackScenario = require('./GamecenterPlaybackScenario');

		for (var i = 0, long = urls.length; i < long; i++) {
			playbacks.push(new GamecenterPlaybackScenario(urls[i]));
		}

		return playbacks;
	}

	return GamecenterVideo;
});
